import { SuppliersApi, useAPIQueryAndQueryKey } from "melco-shared-logic";
import { PublishState } from "../../helper/publishedState";

export const useGetSupplier = (
  supplierId: string,
  publishState: PublishState
) => {
  //  const token = useUserToken();
  //  const impersonationForId = useImpersonationForId();

  // const api = new ControlCenterApi(authenticatedApiConfig());

  //const api = new ControlCenterApi(defaultApiConfig({ token, impersonationForId }));

  return useAPIQueryAndQueryKey(
    SuppliersApi,
    ["supplier", supplierId, publishState],
    async (api) => api.supplierGet({ id: supplierId, publishState })
  );
};
